import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { environment } from "../../../environments/environment";
import { GRUPOS_ENDPOINTS } from "../../components/mediaManager/grupos/grupos-endpoints";
import { Observable, map } from "rxjs";
import { UploadFileHistory } from "../../utils/interfaces/upload-file-history/upload-file-history.interface";
import { BaseApiService } from "../shared/base.api.service";
import { PagedApiResponse } from "../../utils/types/shared/paged-api-response.type";
import { UploadFileHistoryMapper } from "../../utils/mappers/groups/upload-file-history.mapper";
import { SharedMapper } from "../../components/shared/shared.mapper";
import { ObservableDataService } from "../core/observable-data.service";
import { UserSessionType } from "../../utils/types/core/models/user-session.type";

@Injectable({
    providedIn: "root",
})
export class UploadFileHistoryService extends BaseApiService<UploadFileHistory> {
    mapper = new UploadFileHistoryMapper();
    private url = GRUPOS_ENDPOINTS.log;
    private currentUser: UserSessionType;

    constructor(
        private ods: ObservableDataService,
        private httpClient: HttpClient,
        public sharedMapper: SharedMapper
    ) {
        super(httpClient, sharedMapper);
        this.currentUser = this.ods.getLoggedUser();
    }

    public getUploadFileHistory(id: number): Observable<UploadFileHistory[]> {
        let headers = new HttpHeaders();
        headers = headers.set("Content-Type", "application/json");
        headers = headers.set(
            "Authorization",
            `Bearer ${this.currentUser.token}`
        );
        headers = headers.set("apiKey", environment.apiKey);

        return this.httpClient.get<UploadFileHistory[]>(`${this.url}${id}`, {
            headers,
        });
    }
}
